import React from 'react';

interface HeroProps {
  onBookDemo: () => void;
}

const Hero: React.FC<HeroProps> = ({ onBookDemo }) => {
  return (
    <section
      className="relative min-h-screen flex items-center justify-center pt-32 pb-20 overflow-hidden"
      style={{
        backgroundImage: `url('https://supoassets.s3.ap-south-1.amazonaws.com/public/sites/omniviewlabs/assets/Hero/HomePage-1-1.webp')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="absolute inset-0 bg-[#021226] opacity-85"></div>
      <div className="absolute inset-0 bg-gradient-to-t from-[#021226] via-transparent to-[#021226]/40"></div>
      <div className="absolute inset-0 opacity-20 bg-[radial-gradient(circle_at_center,_transparent_0%,_#021226_100%)]"></div>

      {/* Decorative Blur Orbs - Adjusted for Mobile */}
      <div className="absolute top-1/4 left-1/4 w-[300px] md:w-[500px] h-[300px] md:h-[500px] bg-[#003B5C]/20 rounded-full blur-[100px] md:blur-[160px] animate-pulse"></div>
      <div className="absolute bottom-1/4 right-1/4 w-[300px] md:w-[500px] h-[300px] md:h-[500px] bg-[#FF5C00]/5 rounded-full blur-[100px] md:blur-[160px] animate-pulse" style={{ animationDelay: '1.5s' }}></div>

      <div className="relative z-10 container-xl text-center text-white px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-6 md:mb-8 leading-[1.1] tracking-tight animate-reveal">
            We are <br />
            <span className="text-white">
              Omniview Labs.
            </span>
          </h1>
          <p className="text-lg sm:text-xl md:text-2xl max-w-3xl mx-auto mb-10 md:mb-14 text-gray-300/90 font-medium animate-reveal stagger-1 leading-relaxed">
            Supercharging Sales in <span className="text-white border-b-2 border-[#FF5C00]">40+ Furniture Stores</span> Across India.
          </p>

          <div className="flex flex-col sm:flex-row justify-center items-center gap-4 md:gap-6 animate-reveal stagger-2 w-full sm:w-auto">
            <button
              onClick={onBookDemo}
              className="group w-full sm:w-auto bg-[#FF5C00] hover:bg-[#E65200] text-white font-bold py-4 md:py-5 px-8 md:px-14 rounded-full transition-all duration-300 transform hover:-translate-y-1 shadow-2xl hover:shadow-orange-500/40 text-center text-lg md:text-xl flex items-center justify-center gap-3"
            >
              Book a Free Demo
              <svg className="w-6 h-6 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M13 7l5 5m0 0l-5 5m5-5H6" /></svg>
            </button>
            <a
              href="#about"
              className="w-full sm:w-auto glass-dark border-white/10 hover:bg-white hover:text-[#003B5C] text-white font-bold py-4 md:py-5 px-8 md:px-14 rounded-full transition-all duration-300 transform hover:-translate-y-1 text-center text-lg md:text-xl"
            >
              See How It Works
            </a>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 animate-bounce opacity-40">
        <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 14l-7 7-7-7" /></svg>
      </div>
    </section>
  );
};

export default Hero;